ApiError = require 'network/api-error'
logError = require 'debug/log-error'
errorSignal = require 'lib/error-signal'
_ = require 'underscore'
f = require 'effing'

isInterestingError = (err) ->
  err instanceof ApiError.Other || err !instanceof ApiError

pastErrors = []

errorSignal.subscribe _.debounce (errorInfo) ->
  # We want to avoid a situation where a client gets into an infinite error
  # loop and spams us over and over, and our deduplicator fails to detect that.
  if pastErrors.length == 10
    return false

  { error, url, line, col } = errorInfo

  if !isInterestingError(error)
    return false

  # We only care if it's one of our scripts that's having an error.
  # We don't care if it's an extension (or script related to an extension)
  if !(/// https?:// (#{ location.host }|[a-z0-9]+\.cloudfront\.net|a.trellocdn.com) / ///.test(url))
    return false

  errorEntry = [error.message, url, line, col]

  if _.any pastErrors, f(_.isEqual, errorEntry)
    return false

  logError(error, url, line, col)
  pastErrors.push errorEntry
  return false
, 1000, true



// WEBPACK FOOTER //
// ./app/scripts/init/error-logger.coffee